import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const location = useLocation();

  useEffect(() => {
    function handleScroll() {
      setScrolled(window.scrollY > 20);
    }
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setShowCategories(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-white/95 backdrop-blur-md border-b border-background-200/60 shadow-sm' : 'bg-white/80 backdrop-blur-sm border-b border-transparent'
    }`}>
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 flex items-center justify-between h-16">
        <Link to="/" className="font-heading text-lg font-semibold text-foreground-950 cursor-pointer tracking-tight" style={{ fontFamily: 'var(--font-heading)' }}>
          Yoybuy.top
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-label cursor-pointer transition-colors duration-200 whitespace-nowrap ${
              isActive('/') ? 'text-foreground-950 font-medium' : 'text-foreground-500 hover:text-foreground-800'
            }`}
          >
            Главная
          </Link>
          <Link
            to="/guide"
            className={`text-sm font-label cursor-pointer transition-colors duration-200 whitespace-nowrap ${
              isActive('/guide') ? 'text-foreground-950 font-medium' : 'text-foreground-500 hover:text-foreground-800'
            }`}
          >
            Гид по покупкам
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          aria-label="Меню"
        >
          <i className={mobileOpen ? "ri-close-line text-2xl text-foreground-800" : "ri-menu-line text-2xl text-foreground-800"}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-background-100 max-h-[80vh] overflow-y-auto">
          <div className="px-6 py-4 space-y-1">
            <Link
              to="/"
              onClick={() => setMobileOpen(false)}
              className={`block py-3 text-sm font-label cursor-pointer ${
                isActive('/') ? 'text-foreground-950 font-medium' : 'text-foreground-600'
              }`}
            >
              Главная
            </Link>
            <Link
              to="/guide"
              onClick={() => setMobileOpen(false)}
              className={`block py-3 text-sm font-label cursor-pointer ${
                isActive('/guide') ? 'text-foreground-950 font-medium' : 'text-foreground-600'
              }`}
            >
              Гид по покупкам
            </Link>

            <div className="border-t border-background-100 pt-2 mt-1">
              <button
                onClick={() => setShowCategories(!showCategories)}
                className="w-full flex items-center justify-between py-3 text-sm font-label text-foreground-600 cursor-pointer"
              >
                <span>Категории</span>
                <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${showCategories ? 'rotate-180' : ''}`}></i>
              </button>

              {showCategories && (
                <div className="space-y-0.5 pb-2 animate-fadeIn">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      onClick={() => setMobileOpen(false)}
                      className="flex items-center gap-3 py-2.5 px-1 text-sm text-foreground-500 hover:text-foreground-800 cursor-pointer transition-colors duration-200 whitespace-nowrap"
                    >
                      <span className="w-1.5 h-1.5 rounded-full bg-secondary-300 shrink-0"></span>
                      {cat.nameRu}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}